import { Avatar } from "react-native-paper";
import { AvatarText } from "./styled";

type Name = {
  firstName: string | null;
  lastName: string | null;
};

interface Props extends Name {
  profilePhoto?: string;
  size?: number;
  testID?: string;
}

const initials = ({ firstName, lastName }: Name) => [firstName, lastName].map((name) => (name || "")[0]).join("");

const AvatarProfile = ({ profilePhoto, size = 64, testID, ...props }: Props) =>
  profilePhoto ? (
    <Avatar.Image className="bg-sky" size={size} source={{ uri: profilePhoto }} testID={testID} />
  ) : (
    <AvatarText className="bg-sky" labelStyle="text-sky-white font-400" size={size} label={initials(props)} testID={testID} />
  );

export default AvatarProfile;
